import { render, staticRenderFns } from "./SleepModal.vue?vue&type=template&id=b61e544a&scoped=true"
import script from "./SleepModal.vue?vue&type=script&lang=js"
export * from "./SleepModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b61e544a",
  null
  
)

export default component.exports